import { FC } from "react";
import { ICardPartProps } from "./ICardPartProps";
import { PartPage } from "../components";

export const CardPart: FC<ICardPartProps> = ({ pageLink, className }) => {
    return <>
        {(pageLink?.pageId) && <>
            <PartPage
                pageId={pageLink.pageId}
                pageLink={pageLink}
                className={className} />
        </>}
    </>
}
